/**
 * The "Affectation" filter, shared by the Codages and Supervisions pages.
 *
 * One definition of the option, its wording and the query parameter behind it, so the
 * two pages cannot drift apart and so the dashboard links — which carry
 * `?lateAssignment=true` — land on a page that reads the same parameter.
 */

/** Query parameter, both in the page URL and in the API call. */
export const LATE_ASSIGNMENT_PARAM = "lateAssignment";

/** The API takes the string "true"; the filter state holds the same value. */
export const LATE_ASSIGNMENT_VALUE = "true";

export const LATE_ASSIGNMENT_LABEL = "En retard";

export const ASSIGNMENT_FILTER_PLACEHOLDER = "Toutes les affectations";

export const assignmentFilterOptions = () => [
  { value: "", label: ASSIGNMENT_FILTER_PLACEHOLDER },
  { value: LATE_ASSIGNMENT_VALUE, label: LATE_ASSIGNMENT_LABEL },
];

/** Reads the filter's initial value out of the URL the page was opened with. */
export const lateAssignmentFromParams = (params: URLSearchParams) =>
  params.get(LATE_ASSIGNMENT_PARAM) === LATE_ASSIGNMENT_VALUE
    ? LATE_ASSIGNMENT_VALUE
    : "";
